export default __webpack_public_path__ + "static/media/icon-menu-blue.bfa74d9a.svg";